import { Controller } from "@hotwired/stimulus";

// A last-chance "did you forget baggage?" nudge before an itinerary card's
// form actually submits -- ports the mobile "add baggage" modal
// (application_helper.rb#mobile_baggage_modal_options,
// front_mobile/_mobile_itinerary.html.erb) to the new Tailwind/Stimulus
// itinerary card. The modal's own checkboxes are a separate, simplified
// set (one per passenger+bag-type group) that mirror the real underlying
// ancillary checkboxes by name rather than being the same inputs, since a
// single modal option can represent several per-leg checkboxes at once
// (see data-bag-names, a comma-separated list of the real checkbox names
// it should toggle together).
export default class extends Controller {
  static targets = ["trigger", "option", "addButton"];

  connect() {
    this.confirmed = false;
  }

  interceptSubmit(event) {
    if (this.confirmed) return;

    const hasUnselectedOption = this.optionTargets.some((option) => !this.namesAllChecked(option.dataset.bagNames));
    if (!hasUnselectedOption) return;

    event.preventDefault();
    this.pendingForm = event.target;
    this.triggerTarget.click();
  }

  toggleAddButton() {
    const anyChecked = this.optionTargets.some((option) => option.checked);
    if (this.hasAddButtonTarget) this.addButtonTarget.disabled = !anyChecked;
  }

  continueWithout() {
    this.confirmed = true;
    this.submitPendingForm();
  }

  addSelected() {
    this.optionTargets
      .filter((option) => option.checked)
      .forEach((option) => {
        this.namesFor(option).forEach((name) => {
          const realCheckbox = this.element.querySelector(`[name="${CSS.escape(name)}"]`);
          if (!realCheckbox || realCheckbox.checked) return;
          realCheckbox.checked = true;
          realCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });

    this.confirmed = true;
    this.submitPendingForm();
  }

  submitPendingForm() {
    const form = this.pendingForm || this.element.querySelector("form");
    if (form) form.requestSubmit();
  }

  namesFor(option) {
    return (option.dataset.bagNames || "").split(",").filter(Boolean);
  }

  namesAllChecked(bagNames) {
    const names = (bagNames || "").split(",").filter(Boolean);
    if (names.length === 0) return true;
    return names.every((name) => {
      const el = this.element.querySelector(`[name="${CSS.escape(name)}"]`);
      return el ? el.checked : true;
    });
  }
}
